import styled from "styled-components";
import colors from "../../constants/color";

export const Container = styled.div`
  width: 100%;
  padding: 32px;
  margin-top: 104px;
`;

export const PageTitle = styled.h1`
  font-family: Inter;
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 29px;
  letter-spacing: -0.01em;
  color: rgba(0, 0, 0, 0.87);
  margin-bottom: 24px;
`;

export const BodyContainer = styled.div`
  width: 100%;
  padding: 36px;
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  gap: 24px;
  border: 1px;
  margin-top: 1rem;
  background-color: #ffffff;
  box-shadow: rgba(17, 17, 26, 0.05) 0px 1px 0px,
    rgba(17, 17, 26, 0.1) 0px 0px -8px;
`;

export const ContentRow = styled.div`
  display: flex;
  gap: 24px;
`;

export const Column = styled.div`
  width: 100%;
`;

export const Button = styled.button`
  width: 100%;
  height: 50px;
  background: ${colors.primary};
  border-radius: 8px;
  border: none;
  color: #ffffff;
  margin-bottom: 12px;
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 17px;
  letter-spacing: -0.01em;
  cursor: pointer;
  :disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
